<template>
  <div class="rj-page-card">
    <div class="rj-page-card__content">
      <div class="rj-row">
        <el-form ref="form" :model="formData" :rules="rules" label-position="left" label-width="100px" :show-message="showError" hide-required-asterisk>
          <el-form-item prop="byType" label="是否接单:">
            <el-radio-group v-model="formData.byType" @change="changebyType">
              <el-radio :label="1">
                确认接单
              </el-radio>
              <el-radio :label="9">
                拒绝接单
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="formData.byType==9" prop="reason" label-width="0">
            <el-input v-model.trim="formData.reason" type="textarea" :rows="4" placeholder="请输拒绝理由" show-word-limit maxlength="200" />
          </el-form-item>
          <el-form-item style="margin-bottom: 4px" label-width="0">
            <el-button type="primary" :loading="false" @click="submit">
              确认
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { confirmOrRefuseOrder } from '../../../../API/index';
import eventBus from '@/libs/eventBus';
export default {
  data () {
    return {
      formData: {
        byType: 1,
        reason: ''
      },
      loading: false,
      rules: {
        reason: [{ required: true, message: '请输拒绝理由', trigger: 'blur' }],
        byType: [{ required: true, message: '请选择是否接单', trigger: 'change' }]
      },
      showError: true
    };
  },
  props: {
    // 数据由父组件传递
    documentId: {
      type: String,
      default: ''
    }
  },
  components: {},
  computed: {},
  methods: {
    submit () {
      this.$refs.form.validate(async (val) => {
        // 输入验证成功后 调用接口
        if (val) {
          let params = {
            documentId: this.documentId,
            approveComments: '',
            isApproved: '1'
          };
          if (this.formData.byType === 9) {
            params.isApproved = 2;
            params.approveComments = this.formData.reason;
          } else if (this.formData.byType === 1) {
            // params.approveComments = '';
            params.isApproved = 1;
          }
          this.loading = true;
          confirmOrRefuseOrder(params).then((res) => {
            this.loading = false;
            let json = res.data;
            if (json.status === '200') {
              eventBus.$emit('CompleteDistrOrder'); // 完成订单操作
              this.$router.replace({
                name: 'DistributorOrderList'
              });
            }
          }).catch(() => {
            this.loading = false;
          });
        }
        // }
      });
    },
    changebyType (d) {
      // this.$refs.form.resetFields();
      this.$refs.form.validate().catch(() => {});
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss">
</style>
